module.exports = __webpack_public_path__ + "img/hest16.268e8910.jpg";